import { render, staticRenderFns } from "./MillasComponent.vue?vue&type=template&id=ffbb1f5c&scoped=true"
import script from "./MillasComponent.vue?vue&type=script&lang=js"
export * from "./MillasComponent.vue?vue&type=script&lang=js"
import style0 from "./MillasComponent.vue?vue&type=style&index=0&id=ffbb1f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb1f5c",
  null
  
)

export default component.exports